/* Cosmo mega header
   IDs are read from data-* on #cosmo-nav so this file contains no Liquid.
   Mega hover, Esc, mobile drawer, accordions.
   Scroll transparent↔solid only when header[data-transparent="true"]. */
(function(){
  var root = document.getElementById('cosmo-nav');
  if(!root) return;

  var header = document.getElementById(root.dataset.header);
  var scrim  = document.getElementById(root.dataset.scrim);
  if(!header || !scrim) return;

  var triggers = Array.prototype.slice.call(root.querySelectorAll('.nav-item[data-menu]'));
  var panels = {};
  Array.prototype.slice.call(root.querySelectorAll('.mega[data-panel]')).forEach(function(p){
    panels[p.dataset.panel] = p;
  });

  var openKey = null, closeTimer = null;

  function open(key){
    clearTimeout(closeTimer);
    if(openKey === key) return;
    for(var k in panels){ panels[k].classList.toggle('open', k === key); }
    triggers.forEach(function(t){ t.setAttribute('aria-expanded', String(t.dataset.menu === key)); });
    header.classList.add('menu-open');
    scrim.classList.add('show');
    openKey = key;
  }
  function close(){
    if(openKey === null) return;
    for(var k in panels){ panels[k].classList.remove('open'); }
    triggers.forEach(function(t){ t.setAttribute('aria-expanded', 'false'); });
    header.classList.remove('menu-open');
    scrim.classList.remove('show');
    openKey = null;
  }
  function scheduleClose(){ clearTimeout(closeTimer); closeTimer = setTimeout(close, 130); }

  triggers.forEach(function(t){
    var key = t.dataset.menu;
    t.addEventListener('mouseenter', function(){ open(key); });
    t.addEventListener('focus',      function(){ open(key); });
    t.addEventListener('click', function(e){ e.preventDefault(); (openKey === key) ? close() : open(key); });
  });

  // A plain nav link (no menu, e.g. Activate) must CLOSE any open panel on hover —
  // otherwise the previous trigger keeps its "open" pill while this link shows its
  // hover pill, leaving two pills lit at once.
  Array.prototype.slice.call(root.querySelectorAll('.primary-nav .nav-item:not([data-menu])')).forEach(function(a){
    a.addEventListener('mouseenter', close);
  });

  // Keep open while pointer is anywhere in the header (bar + panel); close on leave.
  header.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); });
  header.addEventListener('mouseleave', scheduleClose);
  // Close when focus leaves the header entirely (keyboard).
  header.addEventListener('focusout', function(e){ if(!header.contains(e.relatedTarget)) scheduleClose(); });
  // Moving onto / clicking the dimmed page closes.
  scrim.addEventListener('mouseenter', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && openKey){
      var t = triggers.filter(function(x){ return x.dataset.menu === openKey; })[0];
      close(); if(t) t.focus();
    }
  });

  // Scroll state (transparent → solid). Opaque homepage is the default:
  // only bind when the section is set to sit over a dark hero.
  if(header.dataset.transparent === 'true'){
    function onScroll(){ header.dataset.state = (window.scrollY > 40 ? 'scrolled' : 'top'); }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- Mobile drawer ---------- */
  var body   = document.body,
      ham    = document.getElementById(root.dataset.hamburger),
      drawer = document.getElementById(root.dataset.drawer),
      mClose = document.getElementById(root.dataset.close),
      mScrim = document.getElementById(root.dataset.mscrim);

  function openDrawer(){
    body.classList.add('drawer-open', 'body-lock');
    if(drawer) drawer.setAttribute('aria-hidden', 'false');
    if(ham) ham.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer(){
    body.classList.remove('drawer-open', 'body-lock');
    if(drawer) drawer.setAttribute('aria-hidden', 'true');
    if(ham) ham.setAttribute('aria-expanded', 'false');
  }
  if(ham) ham.addEventListener('click', openDrawer);
  if(mClose) mClose.addEventListener('click', closeDrawer);
  if(mScrim) mScrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && body.classList.contains('drawer-open')) closeDrawer();
  });

  // Accordions
  Array.prototype.slice.call(root.querySelectorAll('.m-acc-btn')).forEach(function(btn){
    btn.addEventListener('click', function(){
      var sec = btn.parentElement, panel = sec.querySelector('.m-acc-panel'), isOpen = sec.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
      panel.style.maxHeight = isOpen ? (panel.scrollHeight + 'px') : '0px';
    });
  });
})();
